module.exports = {"USE":{"Current":42,"Baseline":39},"OVERALL":{"Current":43,"Baseline":40},"ACCESS":{"Current":38,"Baseline":31},"DISPARITY":{"Current":34,"Baseline":41},"medicaid":{"Current":"No","Baseline":"No"},"LIVES":{"Current":44,"Baseline":44},"QUALITY":{"Current":34,"Baseline":35}}


//////////////////
// WEBPACK FOOTER
// ./src/data/ranking/AL.json
// module id = 292
// module chunks = 143196823979170 184088790168614